type ChevronEndIconProps = {
  className?: string;
};

export function ChevronEndIcon({ className }: ChevronEndIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={
        className ?? "shrink-0 text-[color:var(--text-disabled)] rtl:rotate-180"
      }
      aria-hidden="true"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}
